module.exports = __webpack_public_path__ + "img/Quiet-Cove-001.5b7ba03e.jpg";